import { useForm, Controller } from "react-hook-form";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import RecaptchaLoader from "../../lib/RecaptchaLoader";

import {
  Button,
  TextField,
  Typography,
  MenuItem,
  Select,
  Grid,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import DangerTriangle from "../icon/DangerTriangle.svg";
import ErrorIcon from "../icon/error-icon.svg";
import CloseSquare from "../icon/CloseSquare.svg";
import ArrowRightSquare from "../icon/ArrowRightSquare.svg";
import ArrowLeft from "../icon/ArrowLeft.svg";
import Send from "../icon/Send.svg";
import Recaptcha from "react-recaptcha";
import { useStaticQuery, graphql } from "gatsby";
import { toggleMenuItemHoverOff } from "../../redux/reducers/menuItemHover";
import { connect } from "react-redux";
import SuccessImage from "../popups/img/success.svg";
import { ValidateEmail } from "../../lib/helpers";

const useStyles = makeStyles((theme) => ({
  disclaimer: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0px",
    color: "#2F2F4E",
    maxWidth: "calc(100% - 14px)",
    paddingLeft: "4px",
  },
  headerLabel: {
    color: "#3C455C",
    fontSize: "16px !important",
  },
  collapsePopupButton: {
    minWidth: "24px !important",
    width: 24,
    height: 24,
    "&:hover": {
      backgroundColor: "inherit",
    },
  },
  formHeader: {
    marginBottom: "16px",
    borderRadius: "12px 12px 0px 0px",
    background: "#DBE3EF",
    padding: "16px 16px 8px 16px",
  },
  formHeaderNoMarginBottom: {
    borderRadius: "12px 12px 0px 0px",
    background: "#DBE3EF",
    padding: "16px 16px 8px 16px",
  },
  commentText: {
    marginBottom: "16px",
    marginLeft: "16px",
    width: "calc(100% - 32px)",
    "& textarea": {
      padding: "17px 24px",
      lineHeight: "24px",
      height: "95px",
    },
    "& div": {
      padding: 0,
      borderRadius: "8px",
      boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
      backgroundColor: "#F5F7FA",
    },
    "& fieldset": {
      border: "none",
    },
  },
  disclaimerContainer: {
    padding: "8px",
    borderRadius: "8px",
    border: "1px solid #DBE3EF",
    marginBottom: "8px",
    width: "calc(100% - 16px)",
    [theme.breakpoints.down(1275)]: {
      width: "calc(100% - 32px)",
      marginLeft: "16px",
      marginBottom: "16px",
    },
    [theme.breakpoints.down(959)]: {
      width: "calc(100% - 16px)",
      marginLeft: "0",
      marginBottom: "0",
    },
    [theme.breakpoints.down(743)]: {
      width: "calc(100% - 32px)",
      marginLeft: "16px",
      marginBottom: "16px",
    },
  },
  nextButton: {
    backgroundColor: "#DBE3EF !important",
    borderRadius: "8px",
    width: "123px",
    height: "56px",
    marginBottom: "16px",
    marginRight: "16px",
    textTransform: "uppercase",
    [theme.breakpoints.down("xs")]: {
      // maxWidth: "150px",
      // maxHeight: "150px",
      width: "100%",
    },
    "& img": {
      marginLeft: ".4em",
    },
  },
  basicFieldName: {
    marginBottom: "16px",
    marginLeft: "16px",
    width: "calc(100% - 32px)",
    "& input": {},
    "& div": {
      padding: 0,
      borderRadius: "8px",
      boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
      backgroundColor: "#F5F7FA",
    },
    "& fieldset": {
      border: "none",
    },
  },
  basicFieldNameFullWidth: {
    marginBottom: "16px",
    width: "100%",
    "& input": {},
    "& div": {
      padding: 0,
      borderRadius: "8px",
      boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
      backgroundColor: "#F5F7FA",
    },
    "& fieldset": {
      border: "none",
    },
  },
  select: {
    width: "100%",
    borderRadius: "8px",
    padding: "16px, 24px, 16px, 24px",
    "& .MuiPaper-root": {
      left: "24px !important",
      top: "280px !important",
      [theme.breakpoints.down("xs")]: {
        left: "14px !important",
      },
    },
    "& .MuiInputBase-root": {},
  },
  captchaDisclaimer: {
    fontSize: "10px",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0px",
    color: "#8C8CA1",
    width: "calc(100% - 16px)",
    display: "block",
    marginLeft: "16px",
    marginBottom: "16px",
  },
  buttonsContainer: {
    position: "absolute",
    bottom: "16px",
    right: "16px",
    [theme.breakpoints.down(1275)]: {
      position: "initial",
    },
    [theme.breakpoints.down(959)]: {
      position: "absolute",
    },
    [theme.breakpoints.down(743)]: {
      position: "initial",
    },
  },
  popupSubmitButton: {
    backgroundColor: "#FF0F5F",
    padding: "16px 24px",
    [theme.breakpoints.down("xs")]: {
      padding: "16px",
    },
    "&:hover": {
      backgroundColor: "#FF0F5F",
    },
    borderRadius: "8px",
    textTransform: "uppercase",
    [theme.breakpoints.down(1275)]: {
      marginRight: "16px",
      float: "right",
      marginBottom: "16px",
    },
    [theme.breakpoints.down(959)]: {
      marginRight: "0",
      float: "none",
      marginBottom: "0",
    },
    [theme.breakpoints.down(743)]: {
      marginRight: "16px",
      float: "right",
      marginBottom: "16px",
    },
  },
  popupSubmitButtonText: {
    color: "#fff",
    paddingRight: "8px",
    [theme.breakpoints.down(360)]: {
      paddingRight: "initial",
    },
  },
  popupBackButton: {
    padding: "1em",
    background: "#FFFFFF",
    filter: "drop-shadow(0px 2px 4px rgba(64, 64, 64, 0.1))",
    [theme.breakpoints.down("xs")]: {
      padding: "16px",
      marginRight: 0,
    },
    borderRadius: "8px",
    marginRight: "16px",
    border: "1px solid #94A4D6",
    textTransform: "uppercase",
    [theme.breakpoints.down(1275)]: {
      marginLeft: "16px",
      marginBottom: "16px",
    },
    [theme.breakpoints.down(959)]: {
      marginLeft: "0",
      marginBottom: "0",
    },
    [theme.breakpoints.down(743)]: {
      marginLeft: "16px",
      marginBottom: "16px",
    },
  },
  popupBackButtonText: {
    paddingLeft: "8px",
    [theme.breakpoints.down(380)]: {
      paddingLeft: "initial",
    },
  },
  errorLabel: {
    color: "#FF0F5F",
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: "8px",
    marginTop: "4px",
  },
  errorIcon: {
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: "16px",
    marginTop: "4px",
  },
  error: {
    border: "1px solid #FF0F5F",
    borderRadius: "8px",
    marginBottom: "0",
  },
  form: {
    height: "284px",
    position: "relative",
    width: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    marginBottom: "2em",
    boxShadow: "0px 2px 4px rgba(64, 64, 64, 0.1)",
    [theme.breakpoints.down(1275)]: {
      height: "100%",
    },
    [theme.breakpoints.down(959)]: {
      height: "284px",
    },
    [theme.breakpoints.down(743)]: {
      height: "100%",
    },
  },
  recap: {
    display: "none",
  },
  stepLabel: {
    color: "#50586C",
    fontWeight: 400,
    lineHeight: "18px",
    fontSize: "12px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    textAlign: "right",
  },
  textAlignRight: {
    textAlign: "right",
  },
  stepTwoDisclaimerContainer: {
    [theme.breakpoints.down(1275)]: {
      maxWidth: "100%",
      flexBasis: "100%",
    },
    [theme.breakpoints.down(959)]: {
      maxWidth: "50%",
      flexBasis: "50%",
    },
    [theme.breakpoints.down(743)]: {
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  stepTwoFieldsContainer: {
    [theme.breakpoints.down(1275)]: {
      maxWidth: "100%",
      flexBasis: "100%",
    },
    [theme.breakpoints.down(959)]: {
      maxWidth: "50%",
      flexBasis: "50%",
    },
    [theme.breakpoints.down(743)]: {
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  captchaContainer: {
    [theme.breakpoints.down(600)]: {
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  nextButtonContainer: {
    [theme.breakpoints.down(600)]: {
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  nextButtonWrapper: {
    [theme.breakpoints.down(600)]: {
      width: "calc(100% - 32px)",
      marginLeft: "16px",
      marginRight: "16px",
    },
  },
  thankYouTitle: {
    fontFamily: "Poppins",
    fontSize: "24px",
    lineHeight: "36px",
    color: "#3C455C",
    fontWeight: "600",
    display: "block",
    marginLeft: "16px",
    paddingBottom: "16px",
    [theme.breakpoints.down(600)]: {
      textAlign: "center",
      paddingBottom: "1em",
      marginRight: "16px",
    },
  },
  thankYouMessage: {
    color: "#2F2F4E",
    fontSize: "16px",
    lineHeight: "24px",
    display: "block",
    marginLeft: "16px",
    [theme.breakpoints.down(600)]: {
      textAlign: "center",
      marginRight: "16px",
    },
  },
  desktopThankYouImage: {
    float: "right",
    marginRight: "50px",
    [theme.breakpoints.down(1088)]: {
      marginRight: "0",
    },
    [theme.breakpoints.down(959)]: {
      marginRight: "50px",
    },
  },
  mobileThankYouImage: {},
  desktopThankYouImageContainer: {
    textAlign: "center",
    [theme.breakpoints.down(600)]: {
      display: "none",
    },
  },
  mobileThankYouImageContainer: {
    textAlign: "center",
    [theme.breakpoints.up(600)]: {
      display: "none",
    },
  },
  thankYouMessageContainer: {
    [theme.breakpoints.down(600)]: {
      marginBottom: "2.5em",
    },
  },
  formStepTwoFirstNameErrorHeight: {
    height: "304px !important",
    [theme.breakpoints.down(1275)]: {
      height: "initial !important",
    },
    [theme.breakpoints.down(959)]: {
      height: "304px !important",
    },
    [theme.breakpoints.down(743)]: {
      height: "initial !important",
    },
  },
  stepTwoEmailErrorButtonsContainerPadding: {
    bottom: "32px !important",
    [theme.breakpoints.down(1275)]: {
      bottom: "initial !important",
    },
    [theme.breakpoints.down(959)]: {
      bottom: "32px !important",
    },
    [theme.breakpoints.down(743)]: {
      bottom: "initial !important",
    },
  },
  formStepTwoFirstNameAndEmailErrorHeight: {
    height: "313px !important",
    [theme.breakpoints.down(1275)]: {
      height: "initial !important",
    },
    [theme.breakpoints.down(959)]: {
      height: "313px !important",
    },
    [theme.breakpoints.down(743)]: {
      height: "initial !important",
    },
  },
  formStepOneErrorHeight: {
    height: "296px !important",
    [theme.breakpoints.down(1275)]: {
      height: "initial !important",
    },
    [theme.breakpoints.down(959)]: {
      height: "296px !important",
    },
    [theme.breakpoints.down(743)]: {
      height: "initial !important",
    },
  },
  backButtonImage: {
    [theme.breakpoints.down(360)]: {
      display: "none",
    },
  },
  nextButtonImage: {
    [theme.breakpoints.down(360)]: {
      display: "none",
    },
  },
}));

let recaptchaInstance;
const executeCaptcha = (e) => {
  e.preventDefault();
  recaptchaInstance.reset();

  recaptchaInstance.execute();
};

function PostCommentForm(props) {
  const {
    handleSubmit,
    control,
    formState: { errors },
    register,
  } = useForm();

  const { pageId } = props;
  const [showEmailValidationError, setShowEmailValidationError] =
    useState(false);

  var apiURL = process.env.GATSBY_QUESTIONAPI;
  const classes = useStyles();
  function handleOnClickingAwayHandler() {
    props.onClickingAwayHandler();
  }

  function onSubmit(data) {
    var validateEmail = ValidateEmail(data.Email);

    if (!validateEmail) {
      setShowEmailValidationError(true);

      return false;
    }

    var model = {
      ReaderFirstName: data.FirstName,
      ReaderSurname: data.LastName,
      ReaderEmail: data.Email,
      Comment: data.Comment,
      PageId: props.pageId,
      CommentType: props.isInformationPage ? "informationPage" : "articlePage",
    };

    fetch(apiURL + "/AddComment/AddComment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(model),
    })
      .then((response) => response.json())
      .then((data) => console.log(data));

    setStep(3);
  }

  const [step, setStep] = React.useState(1);

  function handleNext(data) {
    data.Comment && setStep(2);
  }
  function handleBack(data) {
    setStep(1);
  }

  const onEmailFocus = function () {
    //console.log("onfocus");
    setShowEmailValidationError(false);
  };

  return (
    <>
      <form
        id="qform"
        className={`${classes.form} ${
          step === 2 &&
          errors.FirstName?.type === "required" &&
          !(errors.Email?.type === "required") &&
          !showEmailValidationError
            ? classes.formStepTwoFirstNameErrorHeight
            : ""
        } ${
          step === 2 &&
          !(errors.FirstName?.type === "required") &&
          (errors.Email?.type === "required" || showEmailValidationError)
            ? classes.formStepTwoFirstNameErrorHeight
            : ""
        } ${
          step === 2 &&
          errors.FirstName?.type === "required" &&
          (errors.Email?.type === "required" || showEmailValidationError)
            ? classes.formStepTwoFirstNameAndEmailErrorHeight
            : ""
        } ${
          step === 1 && errors.Comment?.type === "required"
            ? classes.formStepOneErrorHeight
            : ""
        }`}
      >
        <RecaptchaLoader />
        <Recaptcha
          ref={(e) => (recaptchaInstance = e)}
          sitekey="6LcWa-IbAAAAAAY8dsZcdQVnp8ycB-9iM0dbl6g8"
          size="invisible"
          verifyCallback={handleSubmit(onSubmit)}
          className={classes.recap}
        />

        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={
            step === 3 ? classes.formHeaderNoMarginBottom : classes.formHeader
          }
        >
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={8}>
                <Typography variant="h4" className={classes.headerLabel}>
                  {"Your opinion matters"}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.textAlignRight}></Grid>
            </Grid>
          </Grid>
        </Grid>
        {step === 1 && (
          <div>
            <Controller
              name="Comment"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={4}
                  placeholder={"Leave a comment"}
                  className={`${
                    errors.Comment?.type === "required" ? classes.error : ""
                  } ${classes.commentText}`}
                />
              )}
            />
            {errors.Comment?.type === "required" && (
              <div>
                <img src={ErrorIcon} className={classes.errorIcon} />
                <span className={classes.errorLabel}>
                  {"Comment is required"}
                </span>
              </div>
            )}

            <Grid container alignItems="center" justify="center">
              <Grid item xs={8} className={classes.captchaContainer}>
                <Typography
                  variant="body2"
                  className={classes.captchaDisclaimer}
                >
                  {
                    "This site is protected by reCAPTCHA and the Google Privacy Policy Terms of Service."
                  }
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.nextButtonContainer}>
                <Grid container alignItems="flex-end" justify="flex-end">
                  <Grid item className={classes.nextButtonWrapper}>
                    <Button
                      className={classes.nextButton}
                      onClick={handleSubmit(handleNext)}
                    >
                      <Typography variant="button">{"next"}</Typography>{" "}
                      <img src={ArrowRightSquare} alt="ArrowRightSquare" />
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}
        {step === 2 && (
          <div>
            <Grid container>
              <Grid item xs={6} className={classes.stepTwoFieldsContainer}>
                <Grid container>
                  <Grid item xs={12}>
                    <Controller
                      name="FirstName"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          variant="outlined"
                          placeholder={"First name"}
                          className={`${
                            errors.FirstName?.type === "required"
                              ? classes.error
                              : ""
                          } ${classes.basicFieldName}`}
                          fullWidth
                        />
                      )}
                    />
                    {errors.FirstName?.type === "required" && (
                      <div>
                        <img src={ErrorIcon} className={classes.errorIcon} />
                        <span className={classes.errorLabel}>
                          {"First name is required"}
                        </span>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="LastName"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          variant="outlined"
                          placeholder={"Surname (optional)"}
                          className={`${
                            errors.LastName?.type === "required"
                              ? classes.error
                              : ""
                          } ${classes.basicFieldName}`}
                          fullWidth
                        />
                      )}
                    />
                    {errors.LastName?.type === "required" && (
                      <div>
                        <img src={ErrorIcon} className={classes.errorIcon} />
                        <span className={classes.errorLabel}>
                          {"First name is required"}
                        </span>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="Email"
                      control={control}
                      rules={{
                        required: true,
                      }}
                      onChange={(value) => {
                        //console.log("onchange");
                        setShowEmailValidationError(false);
                      }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          variant="outlined"
                          placeholder={"Email"}
                          className={`${
                            errors.Email?.type === "required" ||
                            showEmailValidationError
                              ? classes.error
                              : ""
                          } ${classes.basicFieldName}`}
                          fullWidth
                          onFocus={onEmailFocus}
                        />
                      )}
                    />
                    {(errors.Email?.type === "required" && (
                      <div>
                        <img src={ErrorIcon} className={classes.errorIcon} />
                        <span className={classes.errorLabel}>
                          {"Email is required"}
                        </span>
                      </div>
                    )) ||
                      (showEmailValidationError && (
                        <div>
                          <img src={ErrorIcon} className={classes.errorIcon} />
                          <span className={classes.errorLabel}>
                            {"Please enter a valid email address"}
                          </span>
                        </div>
                      ))}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} className={classes.stepTwoDisclaimerContainer}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid
                      item
                      container
                      alignItems="flex-start"
                      className={classes.disclaimerContainer}
                    >
                      <Grid item>
                        <img src={DangerTriangle} alt="DangerTriangle" />
                      </Grid>
                      <Grid item className={classes.disclaimer}>
                        <Typography
                          variant="body2"
                          className={classes.disclaimer}
                        >
                          {
                            "We will not share your email or surname with any third party organisations."
                          }
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <div
              container
              item
              justify="space-between"
              className={`${classes.buttonsContainer} ${
                step === 2 &&
                (errors.Email?.type === "required" || showEmailValidationError)
                  ? classes.stepTwoEmailErrorButtonsContainerPadding
                  : ""
              }`}
            >
              <Button
                onClick={() => handleBack()}
                className={classes.popupBackButton}
              >
                <img
                  src={ArrowLeft}
                  alt="ArrowLeft"
                  className={classes.backButtonImage}
                />
                <Typography
                  variant="button"
                  className={classes.popupBackButtonText}
                >
                  {"back"}
                </Typography>
              </Button>
              <Button
                type="submit"
                className={classes.popupSubmitButton}
                onClick={executeCaptcha}
              >
                <Typography
                  variant="button"
                  className={classes.popupSubmitButtonText}
                >
                  {"add comment"}
                </Typography>
                <img
                  src={Send}
                  alt="Send"
                  className={classes.nextButtonImage}
                />
              </Button>
            </div>
          </div>
        )}

        {step === 3 && (
          <Grid container alignItems="center" justify="center">
            <Grid item xs={12} className={classes.mobileThankYouImageContainer}>
              <img src={SuccessImage} className={classes.mobileThankYouImage} />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              className={classes.thankYouMessageContainer}
            >
              <Grid container alignItems="center" justify="center">
                <Grid item xs={12}>
                  <label className={classes.thankYouTitle}>
                    Thank you for contributing!
                  </label>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    className={classes.thankYouMessage}
                  >
                    {
                      "The voice of the customer is the heart of Boring Money’s mission"
                    }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} className={classes.desktopThankYouImageContainer}>
              <img
                src={SuccessImage}
                className={classes.desktopThankYouImage}
              />
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
}

export default PostCommentForm;
